export default __webpack_public_path__ + "static/media/7-3.282a7029.gif";